import {Route, Routes} from "react-router-dom";
import RouteWrapper from "./route-wrapper/RouteWrapper";
import useAppRoutes from "./useAppRoutes";
import ProtectedRoute from "./protected-route/ProtectedRoute";
import DefaultLayout from "../../../layout/default/DefaultLayout";
import NotFound from "../../../layout/default/not-found/NotFound";

export default function AppRoutes() {
    const [routes] = useAppRoutes();

    return (
        <Routes>
            {routes.map((r) => (
                <Route
                    key={r.path}
                    path={r.path}
                    element={
                        <ProtectedRoute showRoute={r.showRoute} redirectTo={r.redirectTo}>
                            <RouteWrapper Component={r.component} Layout={r.layout} title={r.title} />
                        </ProtectedRoute>
                    }
                />
            ))}
            <Route
                path="*"
                element={<RouteWrapper Component={NotFound} Layout={DefaultLayout} title="404"/>}
            />
        </Routes>
    );
}
